<template>
  <div v-if="date != null">
    {{date | formatDate }}
  </div>
</template>

<script>
  import moment from 'moment'
  import 'moment/locale/es'
  moment.locale('es')
  export default {
    props: {
      date: null
    },
    filters: {
      formatDate: function(value) {
        return moment(value).format('LL h:mm:ss a')
      }
    }        
  }
</script>

<style scoped>

</style>